import {
	disableBodyScroll,
	enableBodyScroll,
	clearAllBodyScrollLocks,
} from "body-scroll-lock";

export default class MobileNavigation {
	constructor() {
		this.init();
	}

	init() {
		var hamburger = document.querySelector(".hamburger"),
			navigation = document.querySelector(".mobile-navigation");

		if (hamburger === null) {
			return;
		}

		hamburger.addEventListener("click", (e) => {
			navigation.classList.add("mobile-navigation--animate");
			document.body.classList.toggle("navigation-opened");

			if (document.body.classList.contains("navigation-opened")) {
				disableBodyScroll(navigation, { reserveScrollBarGap: true });
				document.body.classList.add("navigation-opened-prepare");
			} else {
				enableBodyScroll(navigation);

				navigation.addEventListener(
					"animationend",
					() => {
						document.body.classList.remove(
							"navigation-opened-prepare"
						);
					},
					{
						once: true,
					}
				);
			}
		});

		window.addEventListener("resize", (e) => {
			navigation.classList.remove("navigation--animate");
			document.body.classList.remove(
				"navigation-opened",
				"navigation-opened-prepare"
			);
			clearAllBodyScrollLocks();
		});
	}
}
